import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HeatingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HeatingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.27128 6.29299C8.17597 6.40407 8.13812 6.54073 8.16475 6.67739C8.19278 6.82351 8.2937 6.95176 8.44123 7.0292C8.53654 7.07931 8.64692 7.10559 8.76046 7.10559C8.95494 7.10559 9.13785 7.0264 9.24929 6.89429C10.1747 5.80626 9.65892 4.9898 9.28223 4.3934C8.93707 3.84571 8.72858 3.51527 9.24999 2.90169C9.3446 2.79061 9.3821 2.65395 9.35581 2.51764C9.32744 2.37152 9.22651 2.24327 9.07898 2.16548C8.80986 2.02602 8.4556 2.08559 8.27093 2.30074C7.3066 3.43397 7.83362 4.26936 8.21907 4.88083C8.56247 5.42607 8.7517 5.72673 8.27128 6.29299Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6497 6.29317C11.5554 6.4046 11.5183 6.54126 11.5445 6.67757C11.5729 6.82369 11.6738 6.95159 11.8214 7.02903C11.9167 7.07914 12.0267 7.10542 12.1399 7.10542C12.3333 7.10542 12.5162 7.02658 12.6294 6.89412C13.5549 5.80609 13.039 4.98928 12.6624 4.39323C12.3165 3.84624 12.1077 3.5158 12.6298 2.90153C12.724 2.7901 12.7615 2.65344 12.7349 2.51678C12.7065 2.37101 12.6056 2.24276 12.4581 2.16567C12.1893 2.0248 11.8347 2.08367 11.65 2.30093C10.6871 3.43416 11.2134 4.2692 11.5981 4.88067C11.9419 5.42626 12.1315 5.72691 11.6497 6.29317Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0295 6.29328C14.9349 6.40436 14.8974 6.54102 14.9237 6.67733C14.9521 6.82345 15.053 6.9517 15.2005 7.02914C15.2958 7.07925 15.4058 7.10553 15.519 7.10553C15.7139 7.10553 15.8971 7.02634 16.0086 6.89423C16.9343 5.80655 16.4182 4.98974 16.0415 4.39334C15.6956 3.846 15.4871 3.51556 16.0086 2.90163C16.1032 2.79055 16.1407 2.65389 16.1144 2.51758C16.086 2.37146 15.9851 2.24321 15.8375 2.16542C15.5681 2.0249 15.2135 2.08377 15.0295 2.30068C14.0669 3.43356 14.5922 4.2686 14.9773 4.88077C15.321 5.42636 15.5106 5.72702 15.0295 6.29328Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.2114 8.15857H4.78839C3.52025 8.15857 2.48828 9.19053 2.48828 10.4587V18.0945C2.48828 19.363 3.52024 20.395 4.78839 20.395H5.98785V21.4883C5.98785 21.8212 6.25837 22.0917 6.59126 22.0917C6.92415 22.0917 7.19502 21.8212 7.19502 21.4883V20.395H17.0171V21.4883C17.0171 21.8212 17.2876 22.0917 17.6205 22.0917C17.9534 22.0917 18.2243 21.8212 18.2243 21.4883V20.395H19.2114C20.4799 20.395 21.5118 19.363 21.5118 18.0945V10.4587C21.5118 9.19054 20.4799 8.15857 19.2114 8.15857ZM19.2114 19.1878H4.78839C4.18568 19.1878 3.69545 18.6972 3.69545 18.0945V10.4587C3.69545 9.85596 4.18568 9.36573 4.78839 9.36573H19.2114C19.8141 9.36573 20.3047 9.85596 20.3047 10.4587V18.0945C20.3047 18.6972 19.8141 19.1878 19.2114 19.1878Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.16724 10.932C5.83435 10.932 5.56348 11.2025 5.56348 11.5354V17.0183C5.56348 17.3512 5.83435 17.6217 6.16724 17.6217C6.50013 17.6217 6.77065 17.3512 6.77065 17.0183V11.5354C6.77065 11.2025 6.50013 10.932 6.16724 10.932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.92421 10.932C8.59132 10.932 8.3208 11.2025 8.3208 11.5354V17.0183C8.3208 17.3512 8.59132 17.6217 8.92421 17.6217C9.2571 17.6217 9.52797 17.3512 9.52797 17.0183V11.5354C9.52797 11.2025 9.2571 10.932 8.92421 10.932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9999 10.932C11.667 10.932 11.3965 11.2025 11.3965 11.5354V17.0183C11.3965 17.3512 11.667 17.6217 11.9999 17.6217C12.3328 17.6217 12.6037 17.3512 12.6037 17.0183V11.5354C12.6037 11.2025 12.3328 10.932 11.9999 10.932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0754 10.932C14.7425 10.932 14.4717 11.2025 14.4717 11.5354V17.0183C14.4717 17.3512 14.7425 17.6217 15.0754 17.6217C15.4083 17.6217 15.6788 17.3512 15.6788 17.0183V11.5354C15.6788 11.2025 15.4083 10.932 15.0754 10.932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1511 10.932C17.8182 10.932 17.5474 11.2025 17.5474 11.5354V17.0183C17.5474 17.3512 17.8182 17.6217 18.1511 17.6217C18.484 17.6217 18.7545 17.3512 18.7545 17.0183V11.5354C18.7545 11.2025 18.484 10.932 18.1511 10.932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HeatingIcon;
